import { render, staticRenderFns } from "./EducationalPeriodTable.vue?vue&type=template&id=4a3d34d9&"
import script from "./EducationalPeriodTable.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports